import { render, staticRenderFns } from "./StartRightMinutesSubmission.vue?vue&type=template&id=d3eeff4c&"
import script from "./StartRightMinutesSubmission.vue?vue&type=script&lang=js&"
export * from "./StartRightMinutesSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports